import api from "../seller-apis/api";
import store from "../Store";
import { ActionTypes } from "./ActionTypes";

let inflight = null;

export function resetVendorFrozenCheck(dispatch) {
  inflight = null;
  dispatch({ type: ActionTypes.VENDOR_FROZEN_CHECK_RESET });
}

export async function ensureVendorFrozenCheck(dispatch) {
  const s = store.getState().ActionReducer;
  if (s.vendorFrozenCheckResponse != null) {
    return s.vendorFrozenCheckResponse;
  }
  if (inflight) {
    return inflight;
  }
  inflight = (async () => {
    try {
      const response = await api.auth.checkVendorFrozen({});
      dispatch({
        type: ActionTypes.VENDOR_FROZEN_CHECK_SUCCESS,
        payload: response,
      });
      return response;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

/** Force a new `checkVendorFrozen` (e.g. Frozen page manual refresh). */
export async function refreshVendorFrozenCheck(dispatch) {
  resetVendorFrozenCheck(dispatch);
  return ensureVendorFrozenCheck(dispatch);
}
